export const version = `api/${process.env.REACT_APP_VERSION}/`;
export const doctorMessageDetailUrl = version + 'DoctorVideoLibrary/getdoctordetails?drcode=';
export const savestaticvideoplaycountUrl = version + 'DoctorVideoLibrary/savestaticvideoplaycount';
export const savedoctormsgplaycountUrl = version + 'DoctorVideoLibrary/savedoctormsgplaycount';

